import { apiJson, unwrapEnvelope } from './api'
import { fetchWithTimeout } from './http'
import type { Foundation, SchoolUnit, AcademicYear } from '../types/domain'

// Foundations
export async function getFoundations(page: number = 1, limit: number = 100): Promise<{data: Foundation[], meta: {total: number}}> {
  const data = await apiJson<any>(`/organization/foundations?page=${page}&limit=${limit}`, {}, 'Gagal mengambil data yayasan')
  // Assuming API returns array or {data: [], meta: {total}}
  if (Array.isArray(data)) return { data, meta: { total: data.length } }
  return data
}

export async function createFoundation(data: Partial<Foundation>): Promise<Foundation> {
  return apiJson('/organization/foundations', {
    method: 'POST',
    body: JSON.stringify(data),
  }, 'Gagal menambah yayasan')
}

export async function updateFoundation(id: string, data: Partial<Foundation>): Promise<Foundation> {
  return apiJson(`/organization/foundations/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  }, 'Gagal memperbarui yayasan')
}

export async function deleteFoundation(id: string): Promise<void> {
  await apiJson(`/organization/foundations/${id}`, {
    method: 'DELETE',
  }, 'Gagal menghapus yayasan')
}

// School Units (Tenant)
export async function getPublicSchoolUnits(): Promise<{data: SchoolUnit[], meta: {total: number}}> {
  const res = await fetchWithTimeout(`${import.meta.env.VITE_API_BASE_URL || '/api'}/organization/public/school-units`)
  if (!res.ok) throw new Error('Gagal mengambil data unit sekolah')
  const data = unwrapEnvelope(await res.json())
  if (Array.isArray(data)) return { data, meta: { total: data.length } }
  return data
}

export async function getSchoolUnits(page: number = 1, limit: number = 100): Promise<{data: SchoolUnit[], meta: {total: number}}> {
  const data = await apiJson<any>(`/organization/school-units?page=${page}&limit=${limit}`, {}, 'Gagal mengambil data unit')
  if (Array.isArray(data)) return { data, meta: { total: data.length } }
  return data
}

export async function createSchoolUnit(data: Partial<SchoolUnit>): Promise<SchoolUnit> {
  return apiJson('/organization/school-units', {
    method: 'POST',
    body: JSON.stringify(data),
  }, 'Gagal menambah unit')
}

export async function updateSchoolUnit(id: string, data: Partial<SchoolUnit>): Promise<SchoolUnit> {
  return apiJson(`/organization/school-units/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  }, 'Gagal memperbarui unit')
}

export async function deleteSchoolUnit(id: string): Promise<void> {
  await apiJson(`/organization/school-units/${id}`, {
    method: 'DELETE',
  }, 'Gagal menghapus unit')
}

// Academic Years
export async function getAcademicYears(page: number = 1, limit: number = 100): Promise<{data: AcademicYear[], meta: {total: number}}> {
  const data = await apiJson<any>(`/organization/academic-years?page=${page}&limit=${limit}`, {}, 'Gagal mengambil data tahun ajaran')
  if (Array.isArray(data)) return { data, meta: { total: data.length } }
  return data
}

export async function createAcademicYear(data: Partial<AcademicYear>): Promise<AcademicYear> {
  return apiJson('/organization/academic-years', {
    method: 'POST',
    body: JSON.stringify(data),
  }, 'Gagal menambah tahun ajaran')
}

export async function updateAcademicYear(id: string, data: Partial<AcademicYear>): Promise<AcademicYear> {
  return apiJson(`/organization/academic-years/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  }, 'Gagal memperbarui tahun ajaran')
}

export async function deleteAcademicYear(id: string): Promise<void> {
  await apiJson(`/organization/academic-years/${id}`, {
    method: 'DELETE',
  }, 'Gagal menghapus tahun ajaran')
}
